.underlineAlways {
    text-decoration: underline;
}

.underlineOnHover:hover {
    text-decoration: underline;
}